import React, { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserDetails } from "../redux/userThunk";
import { fetchCountNotifications } from "../redux/notificationsThunk";
import { LoadingSpinner } from "../component/Notifications/LoadingSpinner";
import { login } from "../redux/authSlice";
import SocketProvider from "./SocketProvider";
import { setLoading } from "../redux/userSlice";

export const AppContext = createContext();

const AppProvider = ({ children }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  const [isMobile, setIsMobile] = useState(false);

  const {
    list: userDetails,
    loading: userDetailsLoader,
    countryList,
  } = useSelector((state) => state.user);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!userDetails && token) {
      dispatch(fetchUserDetails());
    }
    if (!token) {
      dispatch(setLoading(false));
    }
    if (token) {
      dispatch(fetchCountNotifications());
    }
  }, []);

  useEffect(() => {
    const handleNetworkChange = (online) => {
      if (online) {
        setNetworkStatus("online");
      } else {
        setNetworkStatus("offline");
      }
    };

    window.addEventListener("online", handleNetworkChange);
    window.addEventListener("offline", handleNetworkChange);

    return () => {
      window.removeEventListener("online", handleNetworkChange);
      window.removeEventListener("offline", handleNetworkChange);
    };
  }, []);

  const [networkStatus, setNetworkStatus] = useState(
    navigator.onLine ? "online" : "offline"
  );

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      setIsMobile(window.innerWidth < 768);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      dispatch(login());
    }
  }, [dispatch, isAuthenticated]);

  if (isMobile) {
    return (
      <div className="fixed inset-0 bg-gray-800 bg-opacity-90 flex items-center justify-center z-50">
        <div className="text-center text-white">
          <h1 className="text-2xl font-bold">Web App Unavailable</h1>
          <p className="mt-2">
            This app is not available for mobile devices. Please use a larger
            screen.
          </p>
        </div>
      </div>
    );
  }

  if (userDetailsLoader) {
    return <LoadingSpinner />;
  }

  return (
    <AppContext.Provider value={{}}>
      <SocketProvider>{children}</SocketProvider>
    </AppContext.Provider>
  );
};

export default AppProvider;
